export default {
 licenseAgreement: {
  title: '產品使用許可協議',
  p1: '歡迎使用高盈證券有限公司以下簡稱「高盈證券」）及其關聯公司的APP或PC客戶端軟件及其附帶的產品或服務，包括隨附在其中的所有文檔和文件（ 以下簡稱「本產品」）。我們將竭誠為您提供更全面、更優質的服務。在您使用本產品前，請您仔細閱讀本協議的所有內容。本協議構成您與 「本產品」運營者之間的法律協議。您確認您具備使用本產品和同意本協議的主體資格。',
  p2: '一、定義',
  p3: '1.本協議中，「您」是指使用本產品的一切自然人、法人或非法人組織。',
  p4: '2.本協議中，「使用」是指下載、安裝、應用、訪問或以其他方式通過利用本產品功能的行為。',
  p5: '二、服務條款的接受',
  p6: '當您點擊「立即安裝」或註冊本產品用戶或以其他方式實際使用本產品時，即表示您已經認真閱讀、同意本協議的全部條款，願意受本協議之約束，並已完全了解可能存在的風險，且同意承擔使用本產品及本產品相關服務可能產生的潛在風險。如果您不同意這些條款，請您終止下載、使用本產品並立即刪除本產品及與之相關的文件。',
  p7: '三、服務條款的修訂',
  p8: '1.出於符合監管政策的要求或提高本產品的使用體驗之目的，高盈證券有權隨時修改或變更本協議內容，並只需公示於高盈證券官網或APP而無須征得您的事先同意，請您隨時留意高盈證券官網或APP的動態更新以及手機短信的更新提醒。修改後的條款自在高盈證券官網或APP公示之日起生效。',
  p9: '2.本協議修改或變更後，若您繼續使用本產品的，視為您已經閱讀、了解並接受修改或變更後的條款。如果您不能接受修改或變更後的協議，您應立即停止使用本產品及高盈證券服務，或者及時告知高盈證券您的異議後由高盈證券取消您的用戶資格。',
  p10: '四、用戶帳號註冊',
  p11: '1.高盈證券用戶帳號註冊步驟：登錄高盈證券官網或高盈證券客戶端，進入帳號註冊界面，輸入您個人的有效手機號碼和即時驗證碼，即可註冊成為高盈證券用戶。',
  p12: '2.一旦您註冊成為高盈證券用戶，即表示您同意授權高盈證券向您的手機號碼發送各類信息包括但不限於帳號安全提示信息、手機登錄驗證碼信息、密碼更改提示信息、產品介紹信息、優惠活動信息及其他商業廣告信息。',
  p13: '3.您的用戶帳號註冊成功後，帳號使用權歸屬於您，帳號所有權歸屬於高盈證券。您應提供及時、詳盡及準確的個人資料，並在您的信息發生變更後及時更新註冊資料。如果因您的註冊信息不真實、不準確、不合法有效而引起任何問題、爭議或糾紛，您須自行承擔相關後果及責任，一概與高盈證券無關。為避免因信息不實引發爭議或糾紛，高盈證券有權停止向您提供服務。',
  p14: '4.您的用戶帳號和密碼僅供您本人使用，不得以任何形式轉讓或出借予他人使用。如您發現個人帳號遭他人非法使用或存在安全漏洞，請您立即通知高盈證券。因黑客行為或用戶的保管疏忽導致帳號、密碼遭他人非法使用、竊取、泄露的，高盈證券不承擔任何責任。',
  p15: '5.如果發現同一帳號和密碼在同一時間內被多人同時登陸使用等異常情形，高盈證券可以立即聯系此帳號的原註冊用戶，並有權中止或終止此帳號的用戶資格，且無須承擔任何法律責任。',
  p16: '五、用戶隱私保護',
  p17: '尊重和保護用戶個人隱私是高盈證券一貫遵循的重要原則，高盈證券不對外公開或向第三人提供您的註冊資料或個人信息，除非：',
  p18: '1.事先獲得您的明確授權；',
  p19: '2.根據您的需要，只有提供您的個人資料，才能為您申請、提供您所要求的產品和服務；',
  p20: '3.履行高盈證券的法定責任或保護高盈證券的合法權利之必要；',
  p21: '4.司法、行政及其他有權監管機構依照法定程序執法或監管之必要；',
  p22: '5.根據相應的法律、法規或規章有披露之必要。',
  p23: '請您仔細閱讀我們的《隱私政策》以獲取更多關於用戶個人信息保護的詳情。',
  p24: '六、用戶使用權限',
  p25: '1.下載、安裝和使用：本產品為免費，您可以非商業性、無限製數量地下載、安裝及使用本產品。',
  p26: '2.本產品內可能存在若幹付費功能，請您根據自身情況和實際需要決定是否購買使用。',
  p27: '3.復製和傳播：您可以非商業性、無限製數量地復製和傳播本產品，但必須保證每一份復製和傳播都是完整和真實的，包括所有有關本產品的軟件、電子文檔、版權和商標及本協議的全部內容。',
  p28: '4.本協議下，本產品服務期限自您的用戶帳號註冊成功之日起計算。',
  p29: '七、用戶管理',
  p30: '1.為了規範用戶使用本產品的行為，請您向高盈證券承諾如下：',
  p31: '（1）承諾在遵守法律法規、部門規章、規範性文件及本協議的前提下使用本產品。',
  p32: '（2）承諾不對本產品進行反向工程、反向編譯或反向匯編，同時不得改動編譯在程序文件內部的任何資源。',
  p33: '（3）本產品作為一個單一產品而被授予許可使用，您承諾不會將本產品各個部分分開用於任何目的。',
  p34: '（4）承諾不以出售、出租、出借、贈與、轉讓等方式作經營目的使用。',
  p35: '（5）承諾不為任何非法目的或以任何非法方式使用本產品，並承諾遵守相關法律、法規及其他使用互聯網產品的國際慣例。',
  p36: '（6）承諾不利用高盈證券所提供的服務從事任何違法或侵害他人權益行為。',
  p37: '（7）承諾不通過本產品發布、傳輸任何危害國家安全的、破壞民族團結的、宣揚邪教和封建迷信的、淫穢暴力的、侮辱或誹謗他人的、教唆犯罪的言論、文章、信息等。',
  p38: '（8）承諾不利用本產品從事非法進入其他計算機信息網絡、盜用他人計算機信息資源、惡意篡改計算機數據及應用程序、故意製作及傳播計算機病毒等危害計算機信息網絡安全的行為。',
  p39: '（9）承諾不實施其他依法應被禁止或限製的行為。',
  p40: '2.您需對自己使用本產品服務過程中的所有行為獨立承擔法律責任。一經發現您的行為違反上述承諾，高盈證券有權立即采取如截斷傳輸內容、保存傳輸記錄、關閉用戶帳號、刪除侵權內容鏈接等措施，必要時可以主動向有關監管機構報告。',
  p41: '八、知識產權',
  p42: '1.高盈證券對本產品所使用的軟件、程序、產品架構、產品設計等享有獨立、完整的所有權及知識產權。任何人不得擅自使用、修改、重製、公開播送、改製、散布、發行、公開發表、進行還原工程、解編、反向編譯或以其他方式從本產品取得源代碼，或從本產品中摘取其實質部分作其他應用，否則視為侵權。',
  p43: '2.高盈證券或其他權利人對本產品服務內容中的行情、資訊、熱帖文章、圖片、資料、檔案等享有獨立、完整的所有權及知識產權。未經高盈證券或其他權利人的事前書面同意，任何人不得擅自復製、轉載、篡改或商業引用相關服務內容，亦不得利用上述信息內容向他人收取不正當費用，否則視為侵權。',
  p44: '3.如果您的行為侵犯高盈證券或其他權利人的知識產權的，給高盈證券或其他第三人造成損失的，由您自行承擔一切損害賠償責任包括但不限於訴訟費、取證費及律師費等。',
  p45: '九、風險提示',
  p46: '1.您應充分認識到期貨投資的風險。高盈證券所提供的所有財經金融資訊和行情數據信息，僅供您參考。您在使用本產品過程中，對於上述信息數據內容，不應將其視為高盈證券明示、默示地承諾任何金融產品的投資收益，不應將其視為對任何期貨或衍生品的具體品種選擇/買賣時機的建議，不應將其視為對期貨市場及期貨品種的走勢、投資期貨的可行性分析、預測或建議，或任何其他形式的期貨投資咨詢/建議。',
  p47: '2.高盈證券及其關聯公司將竭力確保所提供信息的可靠性和準確性，但不能保證其絕對可靠和準確。您須謹慎判斷本產品中的行情價格、圖表、評論和購買或者其他信息的準確性，僅作為參考使用。',
  p48: '3.如果您依據高盈證券提供的數據和信息進行期貨投資操作的，應自行承擔一切風險和損失，高盈證券對您的投資決策可能帶來的風險或損失不承擔任何違約、侵權或其他民事責任。',
  p49: '十、免責',
  p50: '1.您須確認已知悉本產品功能及為實現本產品功能所進行的必要操作，根據自身需求自願選擇使用本產品及相關服務。因使用本產品及相關服務所存在的風險和一切後果將完全由您自行承擔，高盈證券不承擔任何責任。',
  p51: '2.本產品經過詳細、嚴密的測試，但不能保證與所有的軟硬件系統完全兼容，不能保證本產品完全沒有錯誤。如果出現不兼容及軟件錯誤的情況，您可以聯系高盈證券，以便獲得相應的技術支持。',
  p52: '3.在適用法律允許的最大範圍內，對因使用或不能使用本產品所產生的損失及風險，包括但不限於直接或間接的個人損害、商業贏利的喪失、貿易中斷、商業信息的丟失或任何其它經濟損失，高盈證券不承擔任何責任。',
  p53: '4.對於因電信系統或互聯網網絡故障、計算機故障或病毒、信息損壞或丟失、計算機系統問題或其它任何不可抗力原因而產生的損失，高盈證券不承擔任何責任。',
  p54: '5.您使用本產品時應當自行采取合理的防護措施。本產品所提供的服務因客觀因素可能會出現中斷、故障等現象，存在造成您使用不便或經濟損失之虞。在此情形下，如您因使用或無法使用本產品所提供的服務而遭受損失的，高盈證券不承擔賠償責任。',
  p55: '6.高盈證券盡力維護本產品的安全性及方便性，但對服務中出現的信息刪除或存儲失敗不承擔任何責任。',
  p56: '7.根據公司經營之需要，高盈證券將會在本產品中刊登、轉載合作公司提供的新聞、資訊、交流文章等內容，刊登、轉載時均會註明內容提供者。基於尊重內容提供者的知識產權，高盈證券對其提供的內容不作任何實質性審查或修改，不保證該內容的真實性，請您自行判斷。特別提示，對於如下信息，高盈證券對客戶、合作夥伴和供應商不承擔任何責任：',
  p57: '（1）任何新聞、文章和信息的準確性；',
  p58: '（2）提供新聞，信息和文章時的任何延遲，不準確，錯誤，中斷或遺漏，以及；',
  p59: '（3）任何新聞，信息和文章的中斷。',
  p60: '若您認為某些內容涉及侵權或不實，請自行向該內容的提供者反映意見。',
  p61: '8.高盈證券發布的任何事實，評估，分析，預測，意見和其他信息（以下簡稱「信息」）均未考慮您的任何投資目標，財務狀況以及特定需求和要求。 因此，除非另有說明，否則高盈證券的所有信息僅用於一般信息和/或營銷目的，不應被解釋為:',
  p62: '（1）財務，投資，稅務或會計建議；',
  p63: '（2）金融產品交易的一般推薦；以及',
  p64: '（3）以任何特定方式鼓勵您進行投資。',
  p65: '9.本產品中包含的信息可在世界範圍內被訪問，但上述信息並不向根據與所在國或所在司法管轄區相關法律相沖突的居民定向提供。',
  p66: '十一、服務終止',
  p67: '1.發生如下任一情形時，高盈證券的服務終止：',
  p68: '（1）您拒絕接受修改後的協議條款，或主動卸載本產品，或以其他形式表明不再使用高盈證券服務的；',
  p69: '（2）因您存在違反本協議的行為，高盈證券有權立即終止服務，並取消您的用戶資格，且無須承擔任何違約責任；',
  p70: '（3）因不可抗力事件發生導致高盈證券無法繼續提供服務的，雙方均有權終止服務，且無須承擔任何違約責任。',
  p71: '前述所稱「不可抗力」，是指超出本協議控製範圍的，不能預見、不能避免或不能克服的所有事件，該事件使得本協議全部或部分不能被履行。這類事件包括但不限於地震、臺風、洪水、火災、戰爭、罷工、暴動、政府行為、法律條文或者其適用發生變化，或者其他任何無法預見、避免或者控製的事件，包括在國際商務實踐中通常被接受為不可抗力的事件。',
  p72: '2.高盈證券服務終止的，您的用戶資格自服務終止之日起失效，且您不再享有使用高盈證券服務的權利，高盈證券亦無須再向您承擔任何義務。',
  p73: '十二、其他',
  p74: '1.本協議的訂立、生效、履行、終止及爭議解決適用香港法律。',
  p75: '2.因本協議的訂立、生效、履行及終止所引起的爭議，高盈證券希望與您友好協商；如協商無法解決問題或協商結果無法令您滿意的，您與高盈證券一致同意提交香港國際仲裁中心依據其屆時現行有效的仲裁規則進行仲裁。',
  p76: '3.如果本協議中的任何條款無論因何種原因完全或部分無效或不具有執行力，或違反任何適用的法律，則該條款自動失效；但本協議的其余條款仍應有效且有約束力。',
  p77: '4.高盈證券對本協議擁有最終解釋權。',
 }
}